import React from "react";
import { string } from "prop-types";

import Image from "../Image";

const SellerCard = ({ className, title, image, description, link }) => {
    const linkButton = () => (
        <a
            className="btn btn-block btn-lx-secondary my-4 mt-md-2 mb-md-0"
            href={link}>
            View Our Store
        </a>
    );

    return (
        <div className="card">
            <div
                className={`card-body d-flex flex-md-row flex-column justify-content-between ${className}`}>
                {image && (
                    <div className="card-top f-basis-25">
                        <div className="image-container text-center">
                            <Image src={image} />
                        </div>
                        {linkButton()}
                    </div>
                )}
                <div className={`card-details ${image ? "f-basis-70" : ""}`}>
                    <h3 className="font-weight-bold">{title}</h3>
                    <p>{description}</p>
                    {!image && linkButton()}
                </div>
            </div>
        </div>
    );
};

SellerCard.defaultProps = {
    className: ""
};

SellerCard.propTypes = {
    className: string,
    title: string,
    image: string,
    description: string,
    link: string
};

export default SellerCard;
